import { createContext } from 'react';
var PopoverContext =
/*#__PURE__*/
createContext({
  isOpen: false,
  open: function open() {
    return void 0;
  },
  close: function close() {
    return void 0;
  },
  getTriggerProps: function getTriggerProps() {
    return void 0;
  },
  getPopoverProps: function getPopoverProps() {
    return void 0;
  },
  rest: {}
});
export { PopoverContext };